import React from 'react';
import { Form } from 'reactstrap';

const PreventEnterSubmitForm = ({ children, ...props }) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
            e.preventDefault();
        }
    };

    return (
        <Form {...props} onKeyDown={handleKeyDown}>
            {children}
        </Form>
    );
};

export default PreventEnterSubmitForm;
